import { render, staticRenderFns } from "./ApplicantsPage.vue?vue&type=template&id=394b3301&"
import script from "./ApplicantsPage.vue?vue&type=script&lang=js&"
export * from "./ApplicantsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports